module.exports = __webpack_public_path__ + "static/logo-traffica-4615a44fb0067d075b3e1a418e1e590d.jpeg";